export const getEventInfo = (type, url) => {
  return JSON.stringify({
    eventAction: `pdp:cross-sell:kohler professional services:${type}`,
    eventName: `pdp:cross-sell:kohler professional services:${type}`,
    eventType: "navigation",
    eventMsg: "n/a",
    eventStatus: "n/a",
    internalLinkName: type,
    internalLinkPosition: "pdp",
    internalLinkType: "pdp:bathroom design services",
    internalLinkZoneName: "pdp:cross-sell:kohler professional services",
    internalLinkURL: url
      ? (url.indexOf("http") === -1 ? window.location.origin : "") + url
      : "n/a",
    clickInternalLinks: "true",
  })
}
